import { Container, DisplayObject, Sprite } from 'pixi.js';
import Core from '../../../Core/Core';
import { app } from '../../../index';
import GameLoader from '../../../Core/Assets';

export class InviteBotImage {
    public static async getInviteFriendBase64Async(): Promise<string> {
        await GameLoader.loadAssetList({ assetList: ['social'] });
        const postFix = Math.random() < 0.5 ? '' : '_1';
        const bg: Sprite = new PIXI.Sprite(
            PIXI.utils.TextureCache[`social/Invite_Friends${postFix}`]
        );
        const avatar: Sprite = await InviteBotImage.getAvatarAsync();
        avatar.position.set(bg.width / 2, 143);
        avatar.width = 200;
        avatar.height = 200;
        return InviteBotImage.getBase64(avatar, bg);
    }

    public static async getFriendJoinedBase64Async(): Promise<string> {
        await GameLoader.loadAssetList({ assetList: ['social'] });
        const bg: Sprite = new PIXI.Sprite(PIXI.utils.TextureCache['social/Friend_Joined']);
        const avatar: Sprite = await InviteBotImage.getAvatarAsync();
        avatar.position.set(160, 140);
        avatar.width = 200;
        avatar.height = 200;
        return InviteBotImage.getBase64(avatar, bg);
    }

    public static async getSendGiftBase64Async(): Promise<string> {
        await GameLoader.loadAssetList({ assetList: ['social'] });
        const bg: Sprite = new PIXI.Sprite(PIXI.utils.TextureCache['social/Receiving_Gift']);
        const avatar: Sprite = await InviteBotImage.getAvatarAsync();
        avatar.position.set(159, 168);
        avatar.width = 180;
        avatar.height = 180;
        avatar.rotation = -0.03;
        return InviteBotImage.getBase64(avatar, bg);
    }

    public static async getSendCoinsBase64Async(): Promise<string> {
        await GameLoader.loadAssetList({ assetList: ['social'] });
        const bg: Sprite = new PIXI.Sprite(PIXI.utils.TextureCache['social/Receiving_Coins']);
        const avatar: Sprite = await InviteBotImage.getAvatarAsync();
        avatar.position.set(159, 168);
        avatar.width = 180;
        avatar.height = 180;
        avatar.rotation = -0.03;
        return InviteBotImage.getBase64(avatar, bg);
    }

    public static async getRequestGiftBase64Async(): Promise<string> {
        await GameLoader.loadAssetList({ assetList: ['social'] });
        const bg: Sprite = new PIXI.Sprite(PIXI.utils.TextureCache['social/Requesting_Gift']);
        const avatar: Sprite = await InviteBotImage.getAvatarAsync();
        avatar.position.set(505, 167);
        avatar.width = 180;
        avatar.height = 180;
        avatar.rotation = 0.02;
        return InviteBotImage.getBase64(avatar, bg);
    }

    public static async getHelperBase64Async(): Promise<string> {
        await GameLoader.loadAssetList({ assetList: ['social'] });
        const bg: Sprite = Sprite.from(PIXI.utils.TextureCache['social/Helper_Friend_Thanks']);
        const avatar: Sprite = await InviteBotImage.getAvatarAsync();
        avatar.position.set(343, 165);
        avatar.width = 180;
        avatar.height = 180;
        return InviteBotImage.getBase64(avatar, bg);
    }

    public static async getAvatarAsync(): Promise<Sprite> {
        const avatar: Sprite = new Sprite();
        avatar.anchor.set(0.5);
        await new Promise<HTMLImageElement>((resolve, reject) => {
            const img: HTMLImageElement = new Image();
            img.crossOrigin = 'anonymous';
            img.src = Core.sdk.user.avatar;
            img.onload = () => resolve(img);
            img.onerror = () => reject();
        }).then((img: HTMLImageElement) => (avatar.texture = PIXI.Texture.from(img)));
        return avatar;
    }

    private static getBase64(...args: DisplayObject[]): string {
        const container: Container = new Container();
        args.forEach((child: DisplayObject) => container.addChild(child));
        return app.renderer.extract.base64(container);
    }
}
